import styled from "@emotion/styled";
import theme from "../../theme/index.js";
import background from "@assets/images/background.webp";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100%;
  margin: -8px -8px -8px -8px;
  font-family: Roboto;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;
const LogoLoginImage = styled.div`
  flex: 1;
  position: relative;
  height: 100vh;
  background-image: url(${background});
  background-color: rgba(0, 0, 0, 0.2);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1000;

  @media (max-width: 1024px) {
    display: flex;
  }

  @media (min-width: 1025px) {
    display: flex;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

const Login = styled.div`
  flex: 1;
  display: flex;
  height: 100%;
  font-size: 12px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.white};
`;

const LoginForm = styled.div`
  background-color: ${theme.colors.white};
  padding: 10px;
  border-radius: 25px;
  width: 60%;
  height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;

  @media (min-width: 768px) {
    width: 60%;
  }

  @media (min-width: 1025px) {
    width: 50%;
  }
`;

const Form = styled.form``;

const LoginImage = styled.img`
  display: none;
  width: 100%;
  height: 100%;
  @media (min-width: 768px) {
    display: block;
    width: 417px;
    height: 311px;
    align-self: center;
  }

  @media (min-width: 1024px) {
    display: flex;
    width: 500px;
    height: 333px;
  }
  @media (min-width: 1440px) {
    display: flex;
    width: 650px;
    height: 440px;
  }
`;

const Label = styled.label`
  color: ${theme.colors.black};
  width: Hug (69px) px;
  height: Hug (19px) px;
  gap: 10px;
  opacity: 0px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 400;
  line-height: 19px;
`;

const TransparentInput = styled.input`
  width: 93%;
  padding: 2px 2px 2px 20px;
  margin-bottom: 10px;
  background-color: transparent;
  color: ${theme.colors.black};
  font-size: 16px;
  font-family: Roboto;
  outline: none;
  border: 1px solid grey;
  border-radius: 5px;
  height: 30px;
  &::placeholder {
    opacity: 0.5;
    color: ${theme.colors.black};
    font-size: 12px;
    font-family: Roboto;
  }
`;

const PasswordInputContainer = styled.div`
  position: relative;
`;
const imagecontainer = styled.img`
  width: 200px;
  height: 60px;
  margin-bottom: 10px;
  object-fit: contain;
`;

const ToggleButton = styled.button`
  position: absolute;
  top: 55%;
  right: 100px;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 12px;
  cursor: pointer;
  color: ${theme.colors.black};
  opacity: 0.5;
  @media (min-width: 768px) {
    top: 55%;
    right: -20px;
  }

  @media (min-width: 1024px) {
    top: 55%;
    right: 0px;
  }
  @media (max-width: 1440px) {
    top: 55%;
    right: -10px;
  }
`;

const Button = styled.button`
  width: 100%;
  border: none;
  background: ${theme.gradient.themeGradient};
  color: ${theme.colors.white};
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 5px;
  margin-top: 5px;
  height: 35px;
  text-align: center;
  gap: 10px;
  border-radius: 8px;
  opacity: 0px;
  @media (min-width: 768px) {
    width: 100%; /* Adjust for larger screens */
  }
  @media (max-width: 768px) {
    width: 100%; /* Adjust for larger screens */
  }
`;
const Heading = styled.p`
  color: #565656;
  margin-top: -10px;
  margin-bottom: 10px;
  font-weight: 500;
  font-family: Roboto;
  font-size: 40px;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 30px;
  }
`;

const ErrorMessage = styled.div`
  color: red;
  margin-top: 10px;
`;

const pdiv = styled.div`
  font-family: Roboto;
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.04em;
  text-align: center;
  position: absolute;
  bottom: 150px;
  width: 100%;
  gap: 0px;
  opacity: 0px;
  color: ${theme.colors.white};
`;

const textspan = styled.span`
  font-family: Roboto;
  font-size: 3rem;
  font-weight: 900;
  letter-spacing: -0.04em;
  text-align: center;
  background: ${theme.gradient.themeGradient};
  -webkit-background-clip: text; /* Clip background to text */
  -webkit-text-fill-color: transparent; /* Make text fill transparent */
`;

const Forgetpass = styled.p`
  text-align: center;
  font-family: Roboto;
  text-decoration: none; /* Change to 'underline' or desired decoration */
  background: ${theme.gradient.themeGradient};
  -webkit-background-clip: text; /* Clip background to text */
  -webkit-text-fill-color: transparent;
`;
const MainDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  position: relative;
  margin-bottom: 10px;
  @media (min-width: 1400px) {
  width:  310px; /* Adjust for larger screens */
  height: 35px;
`;
const ChildDivTwo = styled.div`
  display: flex;
  align-items: center;
  border-radius: 12px;
  height: 2rem;
  background-color: ${theme.colors.white};
  padding: 0 10px;
  font-size: 16px;
  font-weight: bold;
  color: #5b5b5b;
  position: relative;
  z-index: 1;
`;
const ChildDivOneThree = styled.div`
  border-top: 1px dashed ${theme.colors.bordertask};
  flex: 1;
`;
const Cursorimg = styled.img`
  height: 12px;
  width: 12px;
  margin-top: 34px;
`;
const Requestform = styled.div`
  margin-top: 5px;
  display: flex;
  width: 90%;
  height: 60%;
  flex-direction: column;
`;

const bottomDiv = styled.div`
  flex: 1;
  color: white;
  width: 45%;
  position: absolute;
  padding: 30px;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const backButton = styled.button`
  color: #000000;
  width: 100%;
  border: none;
  font-size: 12px;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 35px;
  text-align: center;
  gap: 10px;
  border-radius: 8px;
  opacity: 0px;
  background: white;
`;

const SC = {
  Container,
  LogoLoginImage,
  Login,
  LoginForm,
  LoginImage,
  Label,
  TransparentInput,
  PasswordInputContainer,
  ToggleButton,
  Button,
  Heading,
  ErrorMessage,
  Form,
  pdiv,
  textspan,
  imagecontainer,
  Forgetpass,
  ChildDivOneThree,
  MainDiv,
  ChildDivTwo,
  Requestform,
  Cursorimg,
  backButton,
  bottomDiv,
};

export default SC;
